
import Vue from "vue";
export default Vue.extend({
	i18nEx: {
		componentPrefix: "components.account"
	}
});
